import React from "react";
import { Section, SectionHeading } from "./Section";
import { CheckList } from "./CheckList";
import { OfferCard } from "./OfferCard";
import { volumeTopics, bonusValues, offerItems } from "../data/offer";
export function ValueStack() {
  return <Section tone="dark" data-id="element-249" data-mp="1qafqrxqjy8p4">
      <SectionHeading tone="dark" eyebrow="Your complete professional collection" title="Everything Organized in One Educational Reference System" intro={["Here’s what you’ll receive when you purchase FACIAL AESTHETICS CLINICAL ROADMAP™."]} data-id="element-250" data-mp="1u9y86jj601n7" />

      <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-251" data-mp="2n0gcfnvmk927">
        <div className="flex flex-col rounded-3xl bg-navy-800 p-6 md:p-8" data-id="element-252" data-mp="2965rlhmr0z1f">
          <h3 className="font-serif text-2xl font-bold" data-id="element-253" data-mp="2d8ajaatmzllf">The Six-Volume Collection</h3>
          <p className="mb-5 mt-2 text-[15px] text-white/70" data-id="element-254" data-mp="30yn2wiy8v6ru">Six specialized educational volumes covering:</p>
          <CheckList items={volumeTopics} tone="dark" data-id="element-255" data-mp="35pn07pb9zquv" />
          <p className="mt-6 border-t border-white/10 pt-4 text-[15px] text-white/70 md:mt-auto" data-id="element-256" data-mp="35r7t7ahxz1qm">
            Suggested comparison value: <strong className="text-gold-300" data-id="element-257" data-mp="1og9zjzyfcbyr">$89</strong>
          </p>
        </div>
        <div className="flex flex-col rounded-3xl bg-navy-800 p-6 md:p-8" data-id="element-258" data-mp="1oefhctejexyd">
          <h3 className="font-serif text-2xl font-bold" data-id="element-259" data-mp="236hbdwtxewqh">The Five Professional Bonuses</h3>
          <ul className="mt-5 divide-y divide-white/10" data-id="element-260" data-mp="1ycv8uxhh898e">
            {bonusValues.map(b => <li key={b.name} className="flex items-start justify-between gap-4 py-3 text-[15px] text-white/90" data-id="element-261" data-mp="2c49r323k86ee">
                <span data-id="element-262" data-mp="283zolzez7y4a">{b.name}</span>
                <span className="font-bold text-gold-300" data-id="element-263" data-mp="2m3s8bas35e2r">{b.value}</span>
              </li>)}
          </ul>
          <p className="mt-6 border-t border-white/10 pt-4 text-[15px] text-white/70 md:mt-auto" data-id="element-264" data-mp="2h4o28t0gjwgn">
            Combined suggested comparison value of bonuses: <strong className="text-gold-300" data-id="element-265" data-mp="rs3sl6e157hb">$91</strong>
          </p>
        </div>
      </div>

      <div className="mx-auto mt-8 max-w-2xl overflow-hidden rounded-3xl bg-white text-navy-900" data-id="element-266" data-mp="mt0xadnuqfmj">
        <table className="w-full text-left text-[15px]" data-id="element-267" data-mp="2mv8u65lv7gaz">
          <caption className="bg-gold-400 px-5 py-3 text-left text-sm font-extrabold uppercase tracking-wider text-navy-900" data-id="element-268" data-mp="2rtac2n7k19kv">
            Your complete collection
          </caption>
          <thead data-id="element-269" data-mp="30tgn82fs5xgv">
            <tr className="border-b border-navy-900/10 text-xs uppercase tracking-wider text-navy-900/60" data-id="element-270" data-mp="30u037dlvebs9">
              <th scope="col" className="px-5 py-3 font-bold" data-id="element-271" data-mp="35r8npkuhqrwo">What’s included</th>
              <th scope="col" className="px-5 py-3 text-right font-bold" data-id="element-272" data-mp="3aqbi8bcuhfqe">Comparison value</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-navy-900/10" data-id="element-273" data-mp="3fid1wicce8qg">
            <tr data-id="element-274" data-mp="3jjya3qdxlyub">
              <td className="px-5 py-3.5" data-id="element-275" data-mp="3jidfk0rmafwg">Six-volume educational collection</td>
              <td className="px-5 py-3.5 text-right font-semibold" data-id="element-276" data-mp="3oj1gpf9k8d4e">$89</td>
            </tr>
            <tr data-id="element-277" data-mp="3thcprns16jlk">
              <td className="px-5 py-3.5" data-id="element-278" data-mp="3tgtayfxogbbr">Five specialized bonuses</td>
              <td className="px-5 py-3.5 text-right font-semibold" data-id="element-279" data-mp="7g5elrec1cr8">$91</td>
            </tr>
            <tr data-id="element-280" data-mp="7dsq0ve2k457">
              <td className="px-5 py-3.5 font-bold" data-id="element-281" data-mp="2hc2a2as7rsn">Total suggested comparison value</td>
              <td className="px-5 py-3.5 text-right font-bold text-red-600 line-through" data-id="element-282" data-mp="3tndbe5b6sbbn">$180</td>
            </tr>
            <tr className="bg-cream" data-id="element-283" data-mp="3pm9ynrofqven">
              <td className="px-5 py-4 text-base font-extrabold uppercase" data-id="element-284" data-mp="3pncodwa0ursz">Your price today</td>
              <td className="px-5 py-4 text-right font-serif text-3xl font-extrabold text-cta-hover" data-id="element-285" data-mp="q64z00z8a3ob">$27</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p className="mx-auto mt-4 max-w-2xl text-center text-xs leading-relaxed text-white/55" data-id="element-286" data-mp="ggbqj8udu4oa">
        These are proposed comparison values for the offer presentation, not independently verified market prices.
      </p>

      <div className="mt-12" data-id="element-287" data-mp="18xxsrxm4fsx3">
        <OfferCard heading="Your price: just $27 USD" items={offerItems} ctaLabel="Get the complete collection for $27" note="Digital product · One-time payment" data-id="element-288" data-mp="18z8ulrw0aqlk" />
      </div>
    </Section>;
}